// extracted by mini-css-extract-plugin
export default {"label--small":"GeofenceInteractionTypeRenderer_label--small__aWIWn"};